import { useCV } from '../hooks/useCV'
import Timeline from './Timeline'

const Hero = () => {
  const { name, title, summary, contact, location } = useCV()

  return (
    <section id="home" className="pt-32 sm:pt-36 pb-16 md:pb-24">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-x-10 gap-y-10 items-end">
        <div className="md:col-span-8">
          <p className="text-sm font-medium uppercase tracking-widest text-accent">Welcome to my Portfolio</p>

          <h1 className="mt-4 font-serif text-[2.6rem] leading-[1.05] sm:text-6xl lg:text-7xl font-medium tracking-tight">
            Hi! I'm {name}
          </h1>

          <h2 className="mt-4 font-serif text-2xl sm:text-3xl text-mute">{title}</h2>

          <p className="mt-8 text-lg leading-relaxed text-mute max-w-prose">
            {summary}
          </p>

          <p className="mt-8 flex flex-wrap items-center gap-x-4 gap-y-3 text-base">
            <a
              href={`mailto:${contact.email}`}
              className="bg-ink text-paper px-5 py-2.5 font-medium hover:bg-accent transition-colors"
            >
              Contact Me
            </a>
            <a
              href="#projects"
              className="border border-ink px-5 py-2.5 font-medium hover:bg-ink hover:text-paper transition-colors"
            >
              View Projects
            </a>
          </p>
        </div>

        <figure className="md:col-span-4 max-w-xs md:max-w-none">
          <img
            src="/avatar.jpeg"
            alt={`Portrait of ${name}`}
            className="w-full aspect-[4/5] object-cover rounded-sm"
          />
          <figcaption className="mt-3 text-sm text-mute">{location}</figcaption>
        </figure>
      </div>

      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Timeline />
      </div>
    </section>
  )
}

export default Hero
